import { TileComponent } from "../components/tile.component";

export class TileContainer {
  tileComponents: TileComponent[] = [];
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/services/TileContainer.ts